module.exports = __webpack_public_path__ + "static/media/logo.da042a1c.svg";